module.exports = __webpack_public_path__ + "img/bg222.5c816163.png";